import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppReducerState } from './_reducers';
import { Broadcaster, EVENT_LOADING, EVENT_RESOLUTION } from './_services/broadcast.service';
import { IUserReducer } from './_interfaces';
import { FADE_OUT } from './_animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [FADE_OUT]
})
export class AppComponent implements OnInit {
  user: IUserReducer;
  isPageLoading = false;
  resolution: number = parseInt(localStorage.getItem('resolution'), 10) || 0;
  // resolution = 0;

  constructor(private broadcaster: Broadcaster,
              private store: Store<IAppReducerState>) {
  }

  ngOnInit() {
    this.store.select('user').subscribe((user: IUserReducer) => {
      this.user = user;
    });

    // this.broadcaster.on<boolean>(EVENT_LOADING).subscribe((isLoading) => {
    //   this.isPageLoading = isLoading;
    // });

    this.broadcaster.on<number>(EVENT_RESOLUTION).subscribe((resolution) => {
      this.resolution = resolution;
      this._updateResolution();
    });

    //this._updateResolution();
  }

  private _updateResolution(): void {
    const displayWidth: number = window.innerWidth;
    const zoom: number = (this.resolution > 0) ? displayWidth / this.resolution : 1;

    // @ts-expect-error
    document.body.style.zoom = zoom.toString();
  }

}
